import { VBtn } from 'vuetify/components/VBtn';

export const componentAliases = {
  VSquareBtn: VBtn,
};
